import React from 'react'
import './ProjectVideo.css'

const ProjectVideo = (props) => {
  return (
    <div><iframe width="100%" src={props.video + '?rel=0'} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className='projectVideo'></iframe></div>
  )
}

export default ProjectVideo